import { combineReducers } from 'redux'

import Organizations from './OrganizationsReducer'

export default combineReducers({
	Organizations,
})
